module.exports = __webpack_public_path__ + "img/4-6.e4fae588.png";